/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2022-03-17 17:25:08
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  统计分析 API
 */
export default {
  // GET_menus: '/json/menus.json',


  POST_statisticByFacePassType:'/dqi-hymanage/statistic/statisticByFacePersonType',//人员通行类型统计
  POST_statisticByVehicleType:'/dqi-hymanage/statistic/statisticByVehicleType',//车辆类型统计
  POST_overallInOutStatistic:'/dqi-hymanage/statistic/overallInOut',
  POST_carDeclareApprovalStatistic:'/dqi-hymanage/statistic/carDeclareApproval',
  POST_statisticCarCheckStatus:'/dqi-hymanage/statistic/statisticCarCheckStatus',//车辆申报状态统计
  POST_statisticPersonCheckStatus:'/dqi-hymanage/statistic/statisticPersonCheckStatus',//人员申报状态统计

}



// WEBPACK FOOTER //
// ./src/http/apiModules/tjfx.js